var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"action-button-group"},_vm._l((_vm.buttons),function(button,index){return _c('ActionButton',{key:index,attrs:{"text":button.text},on:{"click":_vm.handleButtonClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }